// Job
import type { I18nLocale } from '#/i18n/types/I18nLocale';

export const searchJobsRoutePathByLocale = {
  en: '/en/jobs',
  es: '/es/empleos',
  pt: '/pt/empregos',
} as const;

export const searchJobsRoutePaths = Object.values(searchJobsRoutePathByLocale);

export const searchJobsRoutePathsWithoutLang = Array.from(
  new Set(searchJobsRoutePaths.map((path) => path.substring(3))),
);

// Internship

export const searchInternshipsRoutePathByLocale = {
  en: '/en/internships',
  es: '/es/pasantias',
  pt: '/pt/estagios',
} as const;

export const searchInternshipsRoutePaths = Object.values(
  searchInternshipsRoutePathByLocale,
);

export const searchInternshipsRoutePathsWithoutLang = Array.from(
  new Set(searchInternshipsRoutePaths.map((path) => path.substring(3))),
);

// volop

export const searchVolopsRoutePathByLocale = {
  en: '/en/volunteer',
  es: '/es/voluntariado',
  pt: '/pt/voluntariado',
} as const;

export const searchVolopsRoutePaths = Object.values(
  searchVolopsRoutePathByLocale,
);

export const searchVolopsRoutePathsWithoutLang = Array.from(
  new Set(searchVolopsRoutePaths.map((path) => path.substring(3))),
);

// Event

export const searchEventsRoutePathByLocale = {
  en: '/en/events',
  es: '/es/eventos',
  pt: '/pt/eventos',
} satisfies Record<I18nLocale, string>;

export const searchEventsRoutePaths = Object.values(
  searchEventsRoutePathByLocale,
);

export const searchEventsRoutePathsWithoutLang = Array.from(
  new Set(searchEventsRoutePaths.map((path) => path.substring(3))),
);

// Org

export const searchOrgsRoutePathByLocale = {
  en: '/en/organizations',
  es: '/es/organizaciones',
  pt: '/pt/organizacoes',
} satisfies Record<I18nLocale, string>;

export const searchOrgsRoutePaths = Object.values(searchOrgsRoutePathByLocale);

export const searchOrgsRoutePathsWithoutLang = Array.from(
  new Set(searchOrgsRoutePaths.map((path) => path.substring(3))),
);
